export const authConfig = {
  domain: process.env.AUTH0_DOMAIN,
  clientId: process.env.AUTH0_CLIENT_ID || 'tfxmbDf1Hw2KZEqYbJFbI3ayLp3wnGcE',
  audience: process.env.AUTH0_AUDIENCE || 'https://dev.api.audo.com',
  appOrigin: '',
  apiOrigin: '',
}
